import { useState, useEffect, useCallback } from 'react';

import { ButtonHero } from '../ButtonHero/ButtonHero.jsx';

import styles from './HeroCtaButton.module.scss';

const CTA_ONBOARDING_DELAY_MS = 200;

export function HeroCtaButton({ 
	text, 
	Icon, 
	onClick, 
	autoExpand = true,
	disableExpand = false,
	className
}) {
	const [isExpanded, setIsExpanded] = useState(false);
	const [hasHoverArmed, setHasHoverArmed] = useState(false);

	useEffect(() => {
		if (!autoExpand) return;
		const timeoutId = window.setTimeout(() => setIsExpanded(true), CTA_ONBOARDING_DELAY_MS);
		return () => window.clearTimeout(timeoutId);
	}, [autoExpand]);

	const handleMouseEnter = useCallback(() => {
		setHasHoverArmed(true);
		setIsExpanded(true);
	}, []);

	const handleMouseLeave = useCallback(() => {
		if (hasHoverArmed) setIsExpanded(false);
	}, [hasHoverArmed]);

	return (
		<ButtonHero
			className={[styles.ctaButton, className, ( isExpanded && !disableExpand ) ? styles.expanded : styles.collapsed].join(' ').trim()}
			onClick={onClick}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onFocus={handleMouseEnter}
			onBlur={handleMouseLeave}
		>
			<span className={styles.ctaText}>{text}</span>
      <Icon className={styles.ctaIcon} isExpanded={isExpanded} />
		</ButtonHero>
	);
}